module.exports = __webpack_public_path__ + "assets/img/greenTick.e0d75eed.png";